import React from 'react';

// Design-system tag: success / warning / error / neutral
export const Tag = ({ tone = 'neutral', children }) => <span className={`tag tag-${tone}`}>{children}</span>;
